// extracted by css-extract-rspack-plugin
export default {"Box":"borderless-text-input-module__Box__crFd6AP"};